__turbopack_context__.v({
  "avatar": "PostSignup-module__Iz2GzW__avatar",
  "feature": "PostSignup-module__Iz2GzW__feature",
  "features": "PostSignup-module__Iz2GzW__features",
  "heading": "PostSignup-module__Iz2GzW__heading",
  "wrapper": "PostSignup-module__Iz2GzW__wrapper",
});
